'use client';
import { saveAICookieForShopify, saveCookieForShopify } from 'eco-design-micro/common/CookieForShopify';
import { fetchPostWeb } from 'eco-design-micro/request2/FetchClient';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import { loginUser } from 'eco-design-micro/utils-user/web/webToken';
import gtm from 'eco-design-reliance/gtm';
import StoreIconA from './IconA';
const authSignIn = async (params: any, otherParmas: any) => {
    return fetchPostWeb('/auth/signIn', params, otherParmas);
};
export default function StoreCommon({ prefixCls, locale, StoreTextA = {} }: { prefixCls: string; locale: string; StoreTextA: any }) {
    // 发起点击
    const clickHandle = async () => {
        if (locale === 'cn') {
            //gotoCnHandle();
        } else {
            gotoShopifyHandle1();
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'top_function',
                button_name: 'Store',
                __btn_id1: `ef-header-store`,
                __btn_id2: `store`,
                __btn_type: 'common',
                __is_shopify_href: true,
            });
        } catch (error) {}
    };
    // 去Shopify
    const gotoShopifyHandle1 = async () => {
        gotoShopifyHandle2();
    };
    const gotoShopifyHandle2 = async () => {
        const isMobile = isH5HandleClient(); //是否是移动端
        let winOpen: any;
        //手机不使用window.open打开
        if (isMobile) {
        } else {
            winOpen = window.open('', '_blank');
        }
        try {
            let url = 'https://us.ecoflow.com';
            switch (locale) {
                case 'cn':
                    url = 'https://mall.jd.com/index-1000363402.html';
                    break;
                case 'jp':
                    url = 'https://jp.ecoflow.com';
                    break;
                case 'cis':
                    url = 'https://ecoflow-russia.com/';
                    break;
                default:
                    url = `https://${locale}.ecoflow.com`;
                    break;
            }
            const token = loginUser()?.token || '';
            if (token) {
                const res = await authSignIn({ url }, { locale, token });
                if (res.code === '0') {
                    url = res.data;
                    const urlArr = url.split('redirect=');
                    if (urlArr.length > 1) {
                        const redirectUrl = urlArr[1];
                        if (
                            redirectUrl.indexOf('.ecoflow.com') === -1 &&
                            (redirectUrl.indexOf('www.') !== -1 || redirectUrl.startsWith('https://') || redirectUrl.startsWith('http://'))
                        ) {
                            url = '/';
                        }
                    }
                }
            }
            // 第三方shopify登录，需要在cookie写入token信息，目前没有选择地区，暂时写us地区
            document.cookie = `us-token=${token};expires=7;` + `domain=.ecoflow.com;path=/`;
            if (isMobile) {
                saveAICookieForShopify(url, locale);
                location.href = saveCookieForShopify(url, locale) || '';
            } else {
                saveAICookieForShopify(url, locale);
                winOpen.location = saveCookieForShopify(url, locale); //兼容safari浏览器
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <button className={`${prefixCls}-bar-item ${prefixCls}-bar-store`} aria-label="store" onClick={clickHandle}>
            <span className={`${prefixCls}-bar-item-msg`}>{StoreTextA.store}</span>
            <StoreIconA />
        </button>
    );
}
